import { render, staticRenderFns } from "./Testimonials.vue?vue&type=template&id=a56406ce&scoped=true&"
import script from "./Testimonials.vue?vue&type=script&lang=ts&"
export * from "./Testimonials.vue?vue&type=script&lang=ts&"
import style0 from "./Testimonials.vue?vue&type=style&index=0&id=a56406ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56406ce",
  null
  
)

export default component.exports